import { Trees } from "lucide-react";
import { useEffect, useState } from "react";

const HERO = "https://customer-assets-v7afamib.emergentagent.net/job_timber-calc-14/artifacts/f2m936jb_Resim1n.jpg";

export default function Login() {
  const [authError, setAuthError] = useState("");
  useEffect(() => {
    try {
      const msg = sessionStorage.getItem("auth_error");
      if (msg) { setAuthError(msg); sessionStorage.removeItem("auth_error"); }
    } catch (_) {}
  }, []);
  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row bg-slate-100">
      <div className="relative hidden md:block md:w-1/2 bg-slate-900 overflow-hidden">
        <img src={HERO} alt="Timber structure" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="relative h-full flex flex-col justify-end p-12">
          <h2 className="font-heading text-4xl font-extrabold text-white leading-tight">
            Build precise timber quotes,<br />in minutes.
          </h2>
          <p className="text-slate-200 mt-3 max-w-md">
            Glulam, CLT and timber-frame cost calculation with live pricing and Excel export.
          </p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-3 mb-8">
            <img src="https://customer-assets-v7afamib.emergentagent.net/job_timber-calc-14/artifacts/vb5x6rvd_Resim8.jpg" alt="NasWood" className="h-11 w-auto object-contain shrink-0" />
            <div>
              <div className="font-heading text-2xl font-extrabold text-slate-900 leading-none tracking-tight">Nas-TimberCalc</div>
              <div className="text-xs text-slate-400">Quoting suite</div>
            </div>
          </div>

          <h1 className="font-heading text-3xl font-extrabold text-slate-900 tracking-tight">Sign in</h1>
          <p className="text-sm text-slate-500 mt-2 mb-8">Continue with your Google account to access your projects and material library.</p>

          {authError && (
            <div data-testid="auth-error" className="mb-6 rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {authError}
            </div>
          )}

          <button onClick={login} data-testid="google-login-btn"
            className="w-full inline-flex items-center justify-center gap-3 rounded-md border border-slate-300 bg-white px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50 hover:border-slate-400 transition-colors shadow-sm">
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            Continue with Google
          </button>

          <p className="text-xs text-slate-400 mt-6 text-center">Secure sign-in managed by Emergent.</p>
        </div>
      </div>
    </div>
  );
}
